"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query {\n  getInspirationFavourites {\n    inspirationId\n    organisationId\n    title\n    description\n    thumbnailUrl\n    assetId\n    tagLine\n    currentUserVote\n    upVotes\n    downVotes\n    createdByUser {\n      firstName\n      lastName\n      imageUrl\n    }\n    isFavourited\n  }\n}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var GET_INSPIRATION_FAVOURITES = (0, _graphqlTag.default)(_templateObject());

var getInspirationFavourites = function getInspirationFavourites() {
  return {
    query: GET_INSPIRATION_FAVOURITES,
    module: 'inspirations',
    ignoreCache: true,
    buildVariables: function buildVariables() {
      return {};
    }
  };
};

var _default = getInspirationFavourites;
exports.default = _default;